<template>
  <v-data-table
    :headers="headers"
    :items="localItems"
    :pagination.sync="pagination"
    :rows-per-page-items="rowsPerPageItems"
    :hide-actions="hideActions"
    :loading="loading"
    :search="search"
    class="elevation-0"
    item-key="id"
  >
    <template v-slot:progress>
      <v-progress-linear
        color="success"
        height="3"
        indeterminate
      />
    </template>

    <template v-slot:items="{ item }">
      <tr>
        <td>
          <router-link :to="linkTo(item)">
            {{ item.trial.name }}
          </router-link>
        </td>
        <td class="no-wrap">
          {{ item.workdate }}
        </td>
        <td>
          {{ item.trial.initiator.username }}
        </td>
        <td>
          {{ item.name }}
        </td>
        <td class="text-xs-center">
          <dashboard-comments-badge
            :commentState="commentState(item)"
          />
        </td>
        <td class="text-xs-center">
          <v-autocomplete
            v-model="item.status"
            @change="setChanged(item)"
            :items="ITEM_STATUS"
            name="status"
            label="Status"
            item-text="name"
            item-value="name"
            :color="statusColor(item.status)"
            class="pa-0 ma-0"
            small
            single-line
            hide-details
            required
          >
            <template v-slot:item="{ item }">
              <v-list-tile-title
                v-text="item.name"
                :class="`${item.color}--text`"
              ></v-list-tile-title>
            </template>
          </v-autocomplete>
        </td>
      </tr>
    </template>

    <template v-slot:actions-append>
      <template v-if="isChanged">
        <v-btn
          @click="resetMixes"
          :disabled="loading"
          flat
          color="warning"
        >
          Reset
        </v-btn>
        <v-btn
          :loading="loading"
          :disabled="loading"
          @click="saveMixes"
          color="success"
        >
          Save
        </v-btn>
      </template>
    </template>
  </v-data-table>
</template>

<script>
import dashboardCommentsBadge from '@/components/comments/dashboardCommentsBadge';

export default {
  name: 'dataTable',
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    headers: {
      type: Array,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      search: '',
      rowsPerPageItems: [
        { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 },
      ],
      hideActions: false,
      isChanged: false,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 3,
        sortBy: 'workdate',
        totalItems: 0,
      },
      localItems: JSON.parse(JSON.stringify(this.items)),
    };
  },
  mounted() {
    this.updatePaginationMeta();
  },
  watch: {
    items: {
      immediate: true,
      handler(items) {
        this.localItems = JSON.parse(JSON.stringify(items));
        this.updatePaginationMeta();
        this.$nextTick(() => {
          this.isChanged = false;
        });
      },
    },
    localItems: {
      deep: true,
      handler() {
        this.isChanged = true;
      },
    },
  },
  methods: {
    commentState(item) {
      return {
        module: 'MIXING',
        id: item.trial_id,
        type: 'trials',
        uniqueId: item.unique_id,
      };
    },
    setChanged(item) {
      item.changed = true;
    },
    updatePaginationMeta() {
      const count = this.items.length;
      const totalPages = Math.ceil(count / this.pagination.rowsPerPage);
      this.pagination.totalItems = count;
      this.hideActions = !count;
      if (count > this.pagination.rowsPerPage) {
        const pages = [];
        for (let i = 0; i < totalPages; i++) {
          if (i !== 0 && i % this.pagination.rowsPerPage === 0) {
            pages.push(i);
            continue;
          }
          pages.push(this.pagination.rowsPerPage);
        }
        this.rowsPerPageItems = [
          ...pages,
          ...this.rowsPerPageItems,
        ];
      }
    },
    resetMixes() {
      this.localItems = JSON.parse(JSON.stringify(this.items));
      this.$nextTick(() => {
        this.isChanged = false;
      });
    },
    saveMixes() {
      this.$emit('saveMixes', this.localItems.filter(item => item.changed));
    },
    linkTo(item) {
      return {
        name: this.allRoutes.trial.children.trialDetail.children.trialMixing.name,
        params: {
          id: item.trial_id,
          from: this.$route.name,
        },
      };
    },
  },
  components: {
    dashboardCommentsBadge,
  },
};
</script>

<style scoped>
table tr {
  border: 0 !important;
  background: none !important;
}

table td,
table th {
  border-right: 1px solid rgb(228, 228, 228);
  border-top: 1px solid rgb(228, 228, 228) !important;
  min-width: 160px;
}

table td:first-child,
table th:first-child {
  border-left: 1px solid rgb(228, 228, 228);
}

table thead tr:first-child th {
  border-top: 1px solid rgb(228, 228, 228);
}

table tr + .v-datatable__expand-row {
  border: 1px solid rgb(228, 228, 228) !important;
  border-bottom: 0 !important;
}

.v-datatable__progress {
  border: 0 !important;
}
</style>
